export default __webpack_public_path__ + "static/plp--story-2-a91247119132b61e705eb01541a34b9c.jpg";